import { render } from "./TextEditorInsertTable.vue?vue&type=template&id=667a7bb8&scoped=true"
import script from "./TextEditorInsertTable.vue?vue&type=script&lang=js"
export * from "./TextEditorInsertTable.vue?vue&type=script&lang=js"

import "./TextEditorInsertTable.vue?vue&type=style&index=0&id=667a7bb8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-667a7bb8"]])

export default __exports__